import type { Attribute } from './product.types';
import { useProductAttributes } from './useProductAttributes';

export function useProductAttribute(id: string): Attribute | undefined {
  const attributes = useProductAttributes();
  return attributes.find(attr => attr.attributeId === id);
}
